import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import { mapMutations, mapState } from "vuex";
import { getLanguageList } from "@/service/i18n";
export default {
  name: "language",
  props: {
    placement: {
      type: String,
      default: "bottom"
    },
    reloadOnChange: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: false,
      languages: [{
        lang: "zh-CN",
        displayName: $t("fwrpxp4", "简体中文"),
        listOrder: 0,
        enabled: true
      }, {
        lang: "en-US",
        displayName: "English",
        listOrder: 1,
        enabled: true
      }, {
        lang: "zh-TW",
        displayName: $t("gkc0dp4", "繁體中文"),
        listOrder: 2,
        enabled: true
      }]
    };
  },
  computed: {
    ...mapState(["user"]),
    ...mapState({
      language: state => state.app.language
    })
  },
  created() {
    this.fetchLanguages();
  },
  methods: {
    ...mapMutations(["setLanguage"]),
    async fetchLanguages() {
      // 以服务端配置及其返回顺序渲染，防止前端语言清单与后台启用状态不一致。
      try {
        const response = await getLanguageList();
        const languageList = response && response.data && response.data.retVal;
        if (!response || !response.data || response.data.result !== 0 || !Array.isArray(languageList)) {
          return;
        }
        this.languages = languageList.filter(item => item && item.enabled && item.lang && item.displayName);
      } catch (error) {
        // 登录页仍可展示语言编码，语言选项会在下次页面初始化时重新请求。
        return null;
      }
    },
    chinseLanguage(language) {
      // 语言列表尚未返回或当前语言被后台停用时，使用语言编码保证控件仍可识别。
      const currentLanguage = this.languages.find(item => item.lang === language);
      return currentLanguage ? currentLanguage.displayName : language;
    },
    async switchLang(type) {
      this.visible = false;
      const lang = type;
      // 先同步 gc-i18n 当前语言，确保远程语言包和运行时 locale 一起更新。
      if (typeof window.$changeLocale === "function") {
        await window.$changeLocale(lang);
      }
      // Vuex/store2 保存页面显示语言，刷新后由应用模块恢复。
      this.setLanguage(lang);
      this.$emit("change", lang);
      // 邀请激活页带有 lang 参数，允许仅切换语言，避免刷新后被旧参数覆盖。
      if (this.reloadOnChange) {
        location.reload();
      }
    }
  }
};